import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import UnderConstruction from './UnderConstruction';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UnderConstruction />
  </React.StrictMode>
);